import styled from '@emotion/styled/macro'
import { Oval } from 'react-loader-spinner'

const Wrap = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
})

interface CenteredLoaderProps {
  size?: number
  minHeight?: number
}

// In-content loader (unlike LoaderOverlay, which covers the whole viewport).
// Use it to show a single clean spinner while a page's data loads, instead of
// letting forms/tables fill in piecemeal.
export const CenteredLoader = ({ size = 64, minHeight = 280 }: CenteredLoaderProps) => (
  <Wrap style={{ minHeight }}>
    <Oval color="#BCF8F2" secondaryColor="#BCF8F2" height={size} width={size} />
  </Wrap>
)
